<template>
  <div class="mouse-control">
    <div class="m-header">
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.4193 8.2526C17.4193 4.70878 14.5464 1.83594 11.0026 1.83594C7.45878 1.83594 4.58594 4.70878 4.58594 8.2526V13.7526C4.58594 17.2964 7.45878 20.1693 11.0026 20.1693C14.5464 20.1693 17.4193 17.2964 17.4193 13.7526V8.2526Z"
          stroke="#C7C7C7"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11 5.5V9.16667"
          stroke="#C7C7C7"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div class="m-title">Управление сенсором</div>
    </div>

    <div class="m-block" style="margin-top: 16px">
      <div>Перемещение</div>

      <svg
        width="52"
        height="24"
        viewBox="0 0 52 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M40 2V22"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M43 19L40 22L37 19"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M47 9L50 12L47 15"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M30 12H50"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M33 9L30 12L33 15"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M37 5L40 2L43 5"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18 11.5V9C18 8.46957 17.7893 7.96086 17.4142 7.58579C17.0391 7.21071 16.5304 7 16 7C15.4696 7 14.9609 7.21071 14.5858 7.58579C14.2107 7.96086 14 8.46957 14 9V10.4"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14 10V8C14 7.46957 13.7893 6.96086 13.4142 6.58579C13.0391 6.21071 12.5304 6 12 6C11.4696 6 10.9609 6.21071 10.5858 6.58579C10.2107 6.96086 10 7.46957 10 8V10"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 9.9V9C10 8.46957 9.78929 7.96086 9.41421 7.58579C9.03914 7.21071 8.53043 7 8 7C7.46957 7 6.96086 7.21071 6.58579 7.58579C6.21071 7.96086 6 8.46957 6 9V14"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 14C6 13.4696 5.78929 12.9609 5.41421 12.5858C5.03914 12.2107 4.53043 12 4 12C3.46957 12 2.96086 12.2107 2.58579 12.5858C2.21071 12.9609 2 13.4696 2 14"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18 11C18 10.4696 18.2107 9.96086 18.5858 9.58579C18.9609 9.21071 19.4696 9 20 9C20.5304 9 21.0391 9.21071 21.4142 9.58579C21.7893 9.96086 22 10.4696 22 11V14C22 16.1217 21.1571 18.1566 19.6569 19.6569C18.1566 21.1571 16.1217 22 14 22H10C7.87827 22 5.84344 21.1571 4.34315 19.6569C2.84285 18.1566 2 16.1217 2 14C2 13.4696 2.21071 12.9609 2.58579 12.5858C2.96086 12.2107 3.46957 12 4 12C4.53043 12 5.03914 12.2107 5.41421 12.5858C5.78929 12.9609 6 13.4696 6 14"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <div class="m-block">
      <div>Поворот</div>

      <svg
        width="80"
        height="24"
        viewBox="0 0 80 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M50 14C50 16.1217 49.1571 18.1566 47.6569 19.6569C46.1566 21.1571 44.1217 22 42 22"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M46 11V10C46 9.46957 45.7893 8.96086 45.4142 8.58579C45.0391 8.21071 44.5304 8 44 8C43.4696 8 42.9609 8.21071 42.5858 8.58579C42.2107 8.96086 42 9.46957 42 10"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M42 10V9C42 8.46957 41.7893 7.96086 41.4142 7.58579C41.0391 7.21071 40.5304 7 40 7C39.4696 7 38.9609 7.21071 38.5858 7.58579C38.2107 7.96086 38 8.46957 38 9V10"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M38 9.5V4C38 3.46957 37.7893 2.96086 37.4142 2.58579C37.0391 2.21071 36.5304 2 36 2C35.4696 2 34.9609 2.21071 34.5858 2.58579C34.2107 2.96086 34 3.46957 34 4V14"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M45.9962 11C45.9962 10.4696 46.2069 9.96086 46.582 9.58579C46.9571 9.21071 47.4658 9 47.9962 9C48.5266 9 49.0353 9.21071 49.4104 9.58579C49.7855 9.96086 49.9962 10.4696 49.9962 11V14C49.9962 16.1217 49.1533 18.1566 47.6531 19.6569C46.1528 21.1571 44.1179 22 41.9962 22H39.9962C37.1962 22 35.4962 21.14 34.0062 19.66L30.4062 16.06C30.0621 15.6789 29.8778 15.1802 29.8913 14.6669C29.9049 14.1537 30.1152 13.6653 30.4789 13.303C30.8426 12.9406 31.3317 12.7319 31.845 12.7202C32.3582 12.7085 32.8564 12.8946 33.2362 13.24L34.9962 15"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22 14C22 16.1217 21.1571 18.1566 19.6569 19.6569C18.1566 21.1571 16.1217 22 14 22"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18 11V10C18 9.46957 17.7893 8.96086 17.4142 8.58579C17.0391 8.21071 16.5304 8 16 8C15.4696 8 14.9609 8.21071 14.5858 8.58579C14.2107 8.96086 14 9.46957 14 10"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14 10V9C14 8.46957 13.7893 7.96086 13.4142 7.58579C13.0391 7.21071 12.5304 7 12 7C11.4696 7 10.9609 7.21071 10.5858 7.58579C10.2107 7.96086 10 8.46957 10 9V10"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 9.5V4C10 3.46957 9.78929 2.96086 9.41421 2.58579C9.03914 2.21071 8.53043 2 8 2C7.46957 2 6.96086 2.21071 6.58579 2.58579C6.21071 2.96086 6 3.46957 6 4V14"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.9962 11C17.9962 10.4696 18.2069 9.96086 18.582 9.58579C18.9571 9.21071 19.4658 9 19.9962 9C20.5266 9 21.0353 9.21071 21.4104 9.58579C21.7855 9.96086 21.9962 10.4696 21.9962 11V14C21.9962 16.1217 21.1533 18.1566 19.6531 19.6569C18.1528 21.1571 16.1179 22 13.9962 22H11.9962C9.1962 22 7.4962 21.14 6.0062 19.66L2.4062 16.06C2.06213 15.6789 1.87778 15.1802 1.89132 14.6669C1.90486 14.1537 2.11524 13.6653 2.47892 13.303C2.84259 12.9406 3.3317 12.7319 3.84497 12.7202C4.35824 12.7085 4.85636 12.8946 5.2362 13.24L6.9962 15"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M59 12C59 9.61305 59.9482 7.32387 61.636 5.63604C63.3239 3.94821 65.6131 3 68 3C70.516 3.00947 72.931 3.99122 74.74 5.74L77 8"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M77 3V8H72"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M77 12C77 14.3869 76.0518 16.6761 74.364 18.364C72.6761 20.0518 70.3869 21 68 21C65.484 20.9905 63.069 20.0088 61.26 18.26L59 16"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M64 16H59V21"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <div class="m-block">
      <div>Приближение</div>

      <svg
        width="80"
        height="24"
        viewBox="0 0 80 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M50 14C50 16.1217 49.1571 18.1566 47.6569 19.6569C46.1566 21.1571 44.1217 22 42 22"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M46 11V10C46 9.46957 45.7893 8.96086 45.4142 8.58579C45.0391 8.21071 44.5304 8 44 8C43.4696 8 42.9609 8.21071 42.5858 8.58579C42.2107 8.96086 42 9.46957 42 10"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M42 10V9C42 8.46957 41.7893 7.96086 41.4142 7.58579C41.0391 7.21071 40.5304 7 40 7C39.4696 7 38.9609 7.21071 38.5858 7.58579C38.2107 7.96086 38 8.46957 38 9V10"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M38 9.5V4C38 3.46957 37.7893 2.96086 37.4142 2.58579C37.0391 2.21071 36.5304 2 36 2C35.4696 2 34.9609 2.21071 34.5858 2.58579C34.2107 2.96086 34 3.46957 34 4V14"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M45.9962 11C45.9962 10.4696 46.2069 9.96086 46.582 9.58579C46.9571 9.21071 47.4658 9 47.9962 9C48.5266 9 49.0353 9.21071 49.4104 9.58579C49.7855 9.96086 49.9962 10.4696 49.9962 11V14C49.9962 16.1217 49.1533 18.1566 47.6531 19.6569C46.1528 21.1571 44.1179 22 41.9962 22H39.9962C37.1962 22 35.4962 21.14 34.0062 19.66L30.4062 16.06C30.0621 15.6789 29.8778 15.1802 29.8913 14.6669C29.9049 14.1537 30.1152 13.6653 30.4789 13.303C30.8426 12.9406 31.3317 12.7319 31.845 12.7202C32.3582 12.7085 32.8564 12.8946 33.2362 13.24L34.9962 15"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22 14C22 16.1217 21.1571 18.1566 19.6569 19.6569C18.1566 21.1571 16.1217 22 14 22"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18 11V10C18 9.46957 17.7893 8.96086 17.4142 8.58579C17.0391 8.21071 16.5304 8 16 8C15.4696 8 14.9609 8.21071 14.5858 8.58579C14.2107 8.96086 14 9.46957 14 10"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14 10V9C14 8.46957 13.7893 7.96086 13.4142 7.58579C13.0391 7.21071 12.5304 7 12 7C11.4696 7 10.9609 7.21071 10.5858 7.58579C10.2107 7.96086 10 8.46957 10 9V10"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 9.5V4C10 3.46957 9.78929 2.96086 9.41421 2.58579C9.03914 2.21071 8.53043 2 8 2C7.46957 2 6.96086 2.21071 6.58579 2.58579C6.21071 2.96086 6 3.46957 6 4V14"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.9962 11C17.9962 10.4696 18.2069 9.96086 18.582 9.58579C18.9571 9.21071 19.4658 9 19.9962 9C20.5266 9 21.0353 9.21071 21.4104 9.58579C21.7855 9.96086 21.9962 10.4696 21.9962 11V14C21.9962 16.1217 21.1533 18.1566 19.6531 19.6569C18.1528 21.1571 16.1179 22 13.9962 22H11.9962C9.1962 22 7.4962 21.14 6.0062 19.66L2.4062 16.06C2.06213 15.6789 1.87778 15.1802 1.89132 14.6669C1.90486 14.1537 2.11524 13.6653 2.47892 13.303C2.84259 12.9406 3.3317 12.7319 3.84497 12.7202C4.35824 12.7085 4.85636 12.8946 5.2362 13.24L6.9962 15"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M58 12H64"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M78 12H72"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M68 2V4"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M68 8V10"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M68 14V16"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M68 20V22"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M75 9L72 12L75 15"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M61 15L64 12L61 9"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
</template>

<style lang="scss">
.mouse-control {
  background-color: #0e0e0f;
  border-style: solid;
  border-width: 2px;
  border-color: #18181a;

  box-sizing: border-box;

  height: 182px;
  width: 352px;

  padding: 16px;

  border-radius: 15px;

  .m-block {
    display: flex;
    justify-content: space-between;

    padding-top: 8px;
    padding-bottom: 8px;

    font-family: "Manrope";
    font-weight: 700;
    font-size: 16px;
    color: white;
  }

  .m-header {
    display: flex;
    align-items: center;

    color: #c7c7c7;

    font-family: "Manrope";
    font-size: 16px;
    font-weight: 700;

    .m-title {
      margin-left: 8px;
    }
  }
}
</style>

<script>
export default {
  name: "MouseControl",
};
</script>
